import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {ExceededModal} from 'entities/user';
import {IncidentsScreen} from 'entities/monitor';
import PortMonitorModal from 'features/port/ui/PortMonitor/PortMonitorModal';
import CreatePortMonitorButton from 'features/port/ui/PortMonitor/CreatePortMonitorButton/CreatePortMonitorButton';
import usePortIncidents from 'features/port/model/usePortIncidents';
import {getPortIncidentColumns} from 'features/port/lib/portIncidentHelper';

import PortIncidentRow from '../PortIncidentRow/PortIncidentRow';
import PortIncidentsFiltersModal from '../PortIncidentsFilters/PortIncidentsFiltersModal';
import PortIncidentsExportModal from '../PortIncidentsExport/PortIncidentsExportModal';

const PortIncidentsScreen: React.FC = () => {
    const {
        timezone,
        sort,
        setSort,
        search,
        onSearch,
        monitors,
        pagination,
        isLoading,
        isFetching,
        unresolvedCount,
        resolvedCount,
        plugState,
        handleRefresh,
        handleCreate,
        isCreateOpen,
        closeCreate,
        isExceededOpen,
        closeExceeded,
    } = usePortIncidents();

    return (
        <IncidentsScreen
            documentTitle={t`Инциденты портов | Overseer`}
            title={i18n._(Pages.PORT_INCIDENTS)}
            backUrl={AppUrls.PORT_MONITORS}
            isFetching={isFetching}
            refetch={handleRefresh}
            summary={{unresolved: unresolvedCount, resolved: resolvedCount}}
            onSubmitSearch={onSearch}
            searchValue={search}
            renderFilterModal={(state) => <PortIncidentsFiltersModal monitors={monitors} {...state}/>}
            renderExportModal={(state) => <PortIncidentsExportModal monitors={monitors} {...state}/>}
            plugState={plugState}
            createButton={<CreatePortMonitorButton onClick={handleCreate}/>}
            createText={t`Добавить порт`}
            onCreate={handleCreate}
            columns={getPortIncidentColumns(false)}
            items={pagination?.items}
            rowFactory={(item) =>
                <PortIncidentRow
                    key={item.uuid}
                    item={item}
                    tzString={timezone}
                />
            }
            isLoading={isLoading}
            pagination={pagination}
            sort={sort}
            setSort={setSort}
        >
            <PortMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
            />

            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeExceeded}
                type="port_monitors"
            />
        </IncidentsScreen>
    );
};

export default PortIncidentsScreen;
